export default __webpack_public_path__ + "static/media/img-slide-1@2x.ce85ed9a.jpeg";